export const GET_ALL_STRATEGIES = 'strategies/GET_ALL_STRATEGIES';
export const GET_ALL_STRATEGIES_SUCCESS = 'strategies/GET_ALL_STRATEGIES_SUCCESS';
export const SET_STRATEGIES_STATUS = 'strategies/SET_STRATEGIES_STATUS';
